// import { startLoading, finishLoading } from '../loading/action.loadings';
import { GET, POST,PUT, POST_FORM } from "./Action";
import {saveToken, setSignOut} from "../authentication/actions";
import cookie from "js-cookie";
import {API_ROUTE} from './apiRoutes';

export const API = 'API';

function checkStatus(response) {
    if (!response.ok) {
        throw {response, statusCode: response.status}
    }
    return response.json()
}

const refresh = (refreshToken, baseRoute) => {
    console.log('refreshToken: ', refreshToken);
    let params = new URLSearchParams();
    params.append('grant_type', 'refresh_token');
    params.append('refresh_token', refreshToken);
    params.append('client_id', 'android');
    return fetch(baseRoute + 'Users/TokenInv', {
        method: 'POST',
        body: params
    })
    .then(res => {
        console.log('response in refreshing')
        if (!res.ok) {
            console.log(res)
            throw new Error('Network response was not ok');
        }
        return res.json()
    })
    .then(data => {
        console.log('json response in refresh')
        if (!data.access_token) {
            return null;
        }
        return data
    })
    .catch((error) => {
        console.error('There has been a problem with your fetch operation:', error);
    });
};


const api = ({ dispatch, getState }) => next => action => {

    if (action.type !== API) {
        return next(action);
    }

    let baseRoute = API_ROUTE;
    // if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
    //     // dev code
    //     baseRoute = 'http://api.danaapp.ir/';
    // } else {
    //     // production code
    //     if (process.browser) { // client side
    //         baseRoute = 'http://api.danaapp.ir/';
    //     }
    //     else{ // server side
    //         baseRoute = 'http://localhost:8060/';
    //     }
    // }

    const { url, success, failed, method, data, loadingActionName } = action.payload;

    console.log('url', url);

    const _url = baseRoute + url;

    // if (loadingActionName) {
    //     dispatch(startLoading(loadingActionName));
    // }

    let request;

    let {token} = getState();
    const tokenInfo = cookie.get('tokenInfo');
    if (!token && tokenInfo) {
        console.log('loading from cookie: ', tokenInfo);
        const parsed = JSON.parse(tokenInfo)
        dispatch(saveToken(parsed));
        token = parsed;
    }

    let authHeaders = {};
    console.log('token: ', token);
    if (token) {
        authHeaders = {
          'Authorization' : `Bearer ${token.access_token}`
        }
    }

    if(method == GET){
        request = fetch(_url, {
          headers: authHeaders
        })
    } else if(method == POST){
        request = fetch(_url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            ...authHeaders
        },
        body: JSON.stringify(data)
        })
    } else if(method == PUT){
        request = fetch(_url, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                ...authHeaders
            },
            body: JSON.stringify(data)
        })
    } else {
        request = fetch(_url, {
          method: 'POST',
          body: data,
          headers: authHeaders
        })
    }
    return request
    .then(checkStatus)
    .then(data => {
      /*if (schema) {
        data = normalize(data, schema);
      }*/
        if(success) {
            next(success(data));
        }
      // if (loadingActionName) {
      //     dispatch(finishLoading(loadingActionName, true));
      // }
    })
    .catch(error => {
        const statusCode = error.statusCode;
        if (statusCode == 401) {
            console.log('catch 401');
            cookie.set('tokenInfo', null);
            dispatch(saveToken(null, true));
            if (!token) {
                return next(setSignOut(true))
            }
            return refresh(token.refresh_token, baseRoute).then(tokenInfo => {
                if (tokenInfo) {
                    dispatch(saveToken(tokenInfo, true));
                    dispatch(action)
                }
            })
        }
        else{
            console.log('in catching error in response', error);
            if (!error.response) {
                if(failed) {
                    next(failed({error: error.FetchError}));
                }
            }
            else{
                console.log(error.response);
                error.response.text().then(error => {
                    if(failed) {
                        next(dispatch(failed({statusCode, error})));
                    }
                    // if (loadingActionName) {
                    //     dispatch(finishLoading(loadingActionName, false));
                    // }
                })
            }
        }
    })
};

export default api;
